import styled from "styled-components";
import { Flex, IconButton, CardBodyContainer, CardImageGradientOverlay, CardHeader, Card } from "@evergis/ui";

export const RecommendedLayersWrapper = styled(Flex)`
  flex-direction: column;
  padding: 1.5rem 0;
`;

export const RecommendedLayersTitleContainer = styled(Flex)`
  flex-wrap: nowrap;
  width: 100%;
  align-items: end;
  justify-content: space-between;
  padding-left: 1.5rem;
  box-sizing: border-box;
`;

export const RecommendedLayersTitle = styled.span`
  opacity: 0.54;
  color: ${({ theme: { palette } }) => palette.textPrimary};
`;

export const RecommendedLayersControls = styled(Flex)`
  flex-wrap: nowrap;
  margin-right: 2.125rem;
`;

export const ControlButton = styled(IconButton)`
  justify-content: end;
`;

export const RecommendedLayersCarousel = styled.div`
  width: 100%;
  margin-top: 1rem;
  height: 8rem;

  .swiper {
    padding-left: 1.375rem;
    padding-right: 1.375rem;
  }

  .swiper-slide {
    width: 9.5rem;
  }
`;

export const LayerSlideCard = styled.div`
  height: 8rem;
  padding: 3px;

  ${CardHeader} {
    font-size: 0.75rem;
    color: black;
    opacity: 0.87;
    left: 1rem;
  }

  ${CardBodyContainer} {
    padding-bottom: 0;
  }

  ${CardImageGradientOverlay} {
    height: 10rem;
    width: 10rem;
  }
`;

export const SlideCard = styled(Card)`
  padding: 0;
  margin: 0;
`;

export const ObjectsCountContainer = styled(Flex)`
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: -0.75rem;
  align-items: center;
  flex-wrap: nowrap;
  opacity: 0.54;
`;
